'use client'

import { Menu, X } from 'lucide-react'

// BIRHAUS: Utility function (replaces @/lib/utils cn)
function cn(...classes: (string | undefined | null | false)[]): string {
  return classes.filter(Boolean).join(' ')
}

interface MobileMenuButtonProps {
  isOpen: boolean
  onToggle: () => void
  collapsible: boolean
  menuLabel: string
  closeMenuLabel: string
  bp: string
}

export function MobileMenuButton({
  isOpen,
  onToggle,
  collapsible,
  menuLabel,
  closeMenuLabel,
  bp
}: MobileMenuButtonProps) {
  if (!collapsible) return null

  return (
    <button
      onClick={onToggle}
      className={cn(
        `${bp}:hidden`,
        'p-2 text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 rounded'
      )}
      aria-expanded={isOpen}
      aria-label={isOpen ? closeMenuLabel : menuLabel}
    >
      {isOpen ? (
        <X className="h-6 w-6" />
      ) : (
        <Menu className="h-6 w-6" />
      )}
    </button>
  )
}
